<template>
  <v-app>
    <TopNavBar />
    <SideBar />

    <v-main>
      <v-breadcrumbs :items="treeStore.elementBreadcrumbs[routeNodeId]">
        <template #title="{ item }">
          <span @click="breadcrumbNavigation(item.route)">{{
            item.title
          }}</span>
        </template>
      </v-breadcrumbs>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { RouterView, useRoute, useRouter } from "vue-router";

// Layout Components
import TopNavBar from "@/components/layout/TopNavBar.vue";
import SideBar from "@/components/layout/SideBar.vue";
import { useTreeStore } from "@/stores/treeStore";

const treeStore = useTreeStore();

const route = useRoute();
const router = useRouter();

const routeNodeId = computed(() => {
  return route.params.nodeId ?? route.params.parentId;
});

function breadcrumbNavigation(route) {
  router.push(route);
}
</script>
